import { Grid, StatCard } from '@cortex/ui';
import { CheckCircle2, Eye, FolderOpen, Zap } from 'lucide-react';

export interface DashboardStatsData {
  totalActive: number;
  awaitingReview: number;
  completedThisMonth: number;
  openProjects: number;
}

interface DashboardStatsProps {
  data: DashboardStatsData;
  onStatClick?: (filter: string) => void;
}

export function DashboardStats({ data, onStatClick }: DashboardStatsProps) {
  return (
    <Grid gap="md" columns={2} className="lg:grid-cols-4">
      <StatCard
        label="Active Requests"
        value={data.totalActive}
        icon={<Zap />}
        variant="primary"
        onClick={onStatClick ? () => onStatClick('active') : undefined}
      />
      <StatCard
        label="Awaiting Review"
        value={data.awaitingReview}
        icon={<Eye />}
        variant="warning"
        onClick={onStatClick ? () => onStatClick('review') : undefined}
      />
      <StatCard
        label="Completed This Month"
        value={data.completedThisMonth}
        icon={<CheckCircle2 />}
        variant="success"
        onClick={onStatClick ? () => onStatClick('completed') : undefined}
      />
      <StatCard
        label="Open Projects"
        value={data.openProjects}
        icon={<FolderOpen />}
        onClick={onStatClick ? () => onStatClick('projects') : undefined}
      />
    </Grid>
  );
}
